// extracted by mini-css-extract-plugin
export default {"recipePager":"style-module--recipePager--e2bd8","focus-visible":"style-module--focus-visible--64252"};